var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "m-notification-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        class: ["m-notification", _vm.customClass, _vm.horizontalClass],
        style: _vm.positionStyle,
        attrs: { role: "alert" },
        on: {
          mouseenter: function ($event) {
            return _vm.clearTimer()
          },
          mouseleave: function ($event) {
            return _vm.startTimer()
          },
          click: _vm.click,
        },
      },
      [
        _vm.type || _vm.iconClass
          ? _c("i", {
              staticClass: "m-notification__icon",
              class: [_vm.typeClass, _vm.iconClass],
            })
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "m-notification__group",
            class: { "is-with-icon": _vm.typeClass || _vm.iconClass },
          },
          [
            _c("h2", {
              staticClass: "m-notification__title",
              domProps: { textContent: _vm._s(_vm.title) },
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.message,
                    expression: "message",
                  },
                ],
                staticClass: "m-notification__content",
              },
              [
                _vm._t("default", function () {
                  return [
                    !_vm.dangerouslyUseHTMLString
                      ? _c("p", [_vm._v(_vm._s(_vm.message))])
                      : _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.message) },
                        }),
                  ]
                }),
              ],
              2
            ),
            _vm.showClose
              ? _c("div", {
                  staticClass: "m-notification__closeBtn m-icon-close",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                })
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }